export const financialHeaders = [
	"Date of Financial",
	"Cash",
	"Current Assets",
	"Total Assets",
	"Current Liabilities",
	"Total Liabilities",
	"Next Income",
	"Retained Earnings",
];

export const bankBalanceHeaders = [
	"Bank Balance Date",
	"Ending Balance",
	"Avg Daily Balance",
];

export const financialDefaultColumns = [
	{ type: "date", name: "dateOfFinancial", value: "" },
	{ type: "currency", name: "cash", value: "" },
	{ type: "currency", name: "currentAssets", value: "" },
	{ type: "currency", name: "totalAssets", value: "" },
	{ type: "currency", name: "currentLiabilities", value: "" },
	{ type: "currency", name: "totalLiabilities", value: "" },
	{ type: "currency", name: "nextIncome", value: "" },
	{ type: "currency", name: "retainedEarnings", value: "" },
];

export const bankBalanceDefaultColumns = [
	{ type: "date", name: "bankBalanceDate", value: "" },
	{ type: "currency", name: "endingBalance", value: "" },
	{ type: "currency", name: "avgDailyBalance", value: "" },
];
